import React from 'react';
import { Button } from 'components';
import {
  WarningIcon,
  WarningIllustration,
  WarningIllustratorSmall,
} from 'icons';
import { useScreenSize } from 'hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface VerificationBlockProps {
  profileStatus?: boolean;
  uploadedIdDoc?: boolean;
  contractConfirmed?: boolean;
  showProfileProcessing?: boolean;
}

export const VerificationBlock = ({ 
  profileStatus = true,
  uploadedIdDoc = true, 
  contractConfirmed = true,
  showProfileProcessing = false
}: VerificationBlockProps) => {
  const { t } = useTranslation();
  const { isMediumScreen, isSmallScreen } = useScreenSize();
  const navigate = useNavigate();
  return (
    <div className="bg-[#FF6F611A] rounded-[16px] md:rounded-3xl flex flex-col md:flex-row gap-[12px] md:gap-24 w-[100%]">
      <div className="flex flex-col pt-[20px] px-[20px] md:pt-8 md:px-8 lg:pb-0 md:pb-11 gap-[12px]">
        <div className="flex gap-3 font-bold text-xl items-center">
          <WarningIcon />
          <p>{t('verificationBlock.completeYourProfile')}</p>
        </div>
        {showProfileProcessing && (
          <p className="text-sm sm:text-base font-medium">
            <span className="text-lg">{t('profileProcessingBanner.icon')}</span>
            {' '}
            {t('profileProcessingBanner.message')}
          </p>
        )}
		{!profileStatus && (
			<p>
			{t(
				'verificationBlock.theInterimEarningsStatementRequiresTheAvsGrossSalary',
			)}
			</p>
		)}
        {!uploadedIdDoc && (
          <p>
            {t('verificationBlock.idDocumentUploadedRequired')}
          </p>
        )}
        {!contractConfirmed && (
          <p>
            {t('verificationBlock.contractConfirmationRequired')}
          </p>
        )}
        <div className="self-stretch sm:self-center md:self-start pb-0 md:pb-[42px]">
          <Button
            onClick={() => navigate('/edit-profile')}
            label={t('verificationBlock.updateNow')}
            fullWidth
          />
        </div>
      </div>
      <div className="pb-[20px] md:pb-0 pr-0 md:pr-8 lg:pr-20 self-center md:self-end max-w-full">
        {isMediumScreen || isSmallScreen ? (
          <WarningIllustratorSmall />
        ) : (
          <WarningIllustration />
        )}
      </div>
    </div>
  );
};
